import React, { useEffect } from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import { useAnnouncementContext } from 'Context/AnnouncementContext';
import DashboardContent from './DashboardContent';

const DashboardContainer = () => {
  const { isInitializing: dashboardIsInitializing, initializingError: dashboardInitializingError } = useDashboardContext();

  // Let an announcement banner be shown on this page
  const {
    banner: {
      setCanBeShown: setBannerCanBeShown,
      initializing: bannerInitializing,
    },
  } = useAnnouncementContext();
  useEffect(() => {
    setBannerCanBeShown(true);
    return () => setBannerCanBeShown(false);
  }, [setBannerCanBeShown]);

  return (
    <DataContainer
      component={DashboardContent}
      loading={dashboardIsInitializing || bannerInitializing}
      loadingError={dashboardInitializingError}
    />
  );
};

export default DashboardContainer;
